<template>
  <div id="mine">
    <div v-show="token">
      <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
      </el-radio-group>
      <el-tabs :tab-position="tabPosition" style="height: auto">
        <el-tab-pane label="意向列表">
          <IntentionList></IntentionList>
        </el-tab-pane>
        <el-tab-pane label="个人信息">
          <Personal @logout="handlelogout()"></Personal>
        </el-tab-pane>
        <el-tab-pane label="修改密码">
          <ChangePassword></ChangePassword>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-show="!token">
      <div class="bg-img">
        <img src="../../assets/images/loginout.png" alt="" />
        <div class="mine-explain">登录后即可使用该模块</div>
        <div class="mine-login" @click="handleLogin($event)">立即登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePassword from "./components/changePassword.vue";
import ExitLogin from "./components/ExitLogin.vue";
import IntentionList from "./components/intentionList.vue";
import Personal from "./components/personal.vue";
export default {
  name: "mine",
  components: {
    ExitLogin,
    ChangePassword,
    IntentionList,
    Personal,
  },
  data() {
    return {
      tabPosition: "left",
      token: "",
    };
  },
  watch: {
    token: {
      handler(val) {},
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initialize();

    // if(this.token=="123"){
    //     this.$router.go(-1)
    // }
  },
  mounted() {
    this.$eventBus.on("isLogin", () => {
      this.initialize();
    });
  },
  methods: {
    initialize() {
      this.token = sessionStorage.getItem("access_token")
        ? sessionStorage.getItem("access_token")
        : "";
    },
    handleLogin() {
      this.$eventBus.emit("isToken", false);
      return;
    },
    // 退出登录
    handlelogout(data) {
      this.token = "";
      this.$eventBus.emit("isMine", false);
    },
  },
};
</script>

<style scoped>
#mine {
  width: 45%;
  margin: 0 auto;
  background: white;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 500px; */
  padding-bottom: 350px;
}

.bg-img {
  width: 388px;
  height: 388px;
  margin: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  /* background: red; */
}

.bg-img img {
}

.mine-explain {
  margin-top: 10px;
  color: #7c7c7c;
  font-size: 0.85rem;
}
.mine-login {
  margin-top: 30px;
  width: 188px;
  height: 50px;
  background: #3f8bfd;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  cursor: pointer;
}
</style>